import { useTranslation } from "react-i18next";
import { FaFilter } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { FilterAction } from "../../../redux/states/filterState";

export type Props = {};

const SmallFilterAccessor: React.FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const openModal = (): void => {
    dispatch(FilterAction.SetOpenFilterModal(true));
  };

  return (
    <div className="mobile-filter-container">
      <button
        id="mobile-filter-button"
        className="mobile-filter"
        onClick={openModal}
        aria-label={t("aria-label--modal-filter--open") || undefined}
        aria-controls="filter-modal"
      >
        <FaFilter></FaFilter>
        <span className="mobile-filter-label">
          {t("mobile_display_filter")}
        </span>
      </button>
    </div>
  );
};

export default SmallFilterAccessor;
